module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fieldName == 'groupId') ? _c('el-cascader', {
    ref: "cascader",
    staticClass: "arriveClass orgList",
    staticStyle: {
      "width": "100%",
      "display": "inline-block"
    },
    attrs: {
      "placeholder": _vm.Language('请选择'),
      "show-all-levels": false,
      "clearable": "",
      "filterable": "",
      "options": _vm.orgList,
      "props": {
        expandTrigger: 'hover',
        label: 'orgName',
        value: 'orgId',
        checkStrictly: true
      },
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return' || (_vm.orderStatus && _vm.orderStatus != '0')
    },
    on: {
      "change": _vm.orgChange
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  }) : (_vm.fieldName == 'labMsg') ? _c('el-cascader', {
    ref: "cascader",
    staticClass: "arriveClass orgList",
    staticStyle: {
      "width": "100%",
      "display": "inline-block"
    },
    attrs: {
      "placeholder": _vm.Language('请选择'),
      "show-all-levels": false,
      "clearable": "",
      "filterable": "",
      "options": _vm.labList,
      "props": {
        expandTrigger: 'hover',
        label: 'labName',
        value: 'id',
        checkStrictly: true
      },
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
    },
    on: {
      "change": _vm.orgChange
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  }) : _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return' || (_vm.fieldNameList.indexOf(_vm.fieldName) > -1 && _vm.orderStatus && _vm.orderStatus != '0') || (_vm.editType == 'hotline' && (_vm.fieldName == 'originType' || _vm.fieldName == 'originId')),
      "filterable": "",
      "multiple": _vm.dataMultiple == 2 ? true : false,
      "placeholder": _vm.Language('请选择'),
      "default-first-option": ""
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  }, [(_vm.fieldName == 'cusId') ? _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.cusName,
        "value": item.id
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.fieldName == 'cId') ? _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }) : (_vm.fieldName == 'userId' || _vm.fieldName == 'createOper') ? _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.agentName,
        "value": item.userId
      }
    })
  }) : (_vm.fieldName == 'status') ? _vm._l((_vm.statusList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item,
        "value": index
      }
    })
  }) : (_vm.fieldName == 'levelCode' || _vm.fieldName == 'priorityCode' || _vm.fieldName == 'orderTypeCode') ? _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }) : (_vm.fieldName == 'originId') ? _vm._l((_vm.originList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.originName,
        "value": item.originId
      }
    })
  }) : _vm._l((_vm.filterData), function(item) {
    return _c('el-option', {
      key: item.dictCode,
      attrs: {
        "label": item.dictName,
        "value": item.dictCode
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-07203e60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Sass/components/SelectList.vue
// module id = 1318
// module chunks = 5